Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    focused = _STYLES$useStyles.focused,
    disabled = _STYLES$useStyles.disabled,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var row = {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    position: 'relative'
  };
  var touchableArea = {
    paddingHorizontal: (0, _styles.getREM)(0.5625)
  };
  var gutter = {
    backgroundColor: COLORS.steam,
    height: (0, _styles.getREM)(1.5625),
    width: (0, _styles.getREM)(3.125),
    borderRadius: (0, _styles.getREM)(0.78125)
  };
  var thumb = {
    backgroundColor: COLORS.aubergine,
    height: (0, _styles.getREM)(1.5625),
    width: (0, _styles.getREM)(1.5625),
    borderRadius: (0, _styles.getREM)(0.78125)
  };
  var text = Object.assign({}, fontSemiBold, {
    color: COLORS.doveGrey,
    textTransform: 'capitalize',
    lineHeight: _styles.STYLES.lineHeight.s,
    fontSize: _styles.STYLES.fontSize.s
  });
  var activeText = Object.assign({}, fontSemiBold, {
    color: COLORS.aubergine,
    textTransform: 'capitalize',
    lineHeight: _styles.STYLES.lineHeight.s,
    fontSize: _styles.STYLES.fontSize.s
  });
  var button = Object.assign({
    position: 'absolute',
    zIndex: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'transparent',
    borderWidth: 0,
    borderColor: 'transparent',
    padding: 0,
    margin: 0,
    width: '100%'
  }, _reactNative.Platform.select({
    web: {
      cursor: 'pointer'
    }
  }));
  var button_focused = Object.assign({}, focused, {
    outlineOffset: (0, _styles.getREM)(0.25),
    borderRadius: (0, _styles.getREM)(0.25)
  });
  var styles = _reactNative.StyleSheet.create({
    row: row,
    gutter: gutter,
    thumb: thumb,
    touchableArea: touchableArea,
    text: text,
    activeText: activeText,
    button: button,
    button_focused: button_focused,
    disabled: disabled
  });
  return {
    styles: styles
  };
};